export default "__VITE_ASSET__BPVtiQ_O__"